import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";




const Notifications = () => 
{ 
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [filteredNotificationsData, setFilteredNotificationsData] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const isNonMobile = useMediaQuery("(min-width:620px)");
    

    const [notificationsData, setNotificationsData] = useState([{
        notificationId: 0,
        title: "",
        message: "",
        userId: 0,
        read: 0,
        notificationDate:"",

        userIds : null,
        user: null
    }]);

    const [tabValue, setTabValue] = useState(0);
      const getDecryptedToken = () => {
        const encryptedToken = Cookies.get("token");
        if (!encryptedToken) return null;
    
        const secretKey = '19092002'; 
        const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
        const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    
        return decryptedToken || null;
      };
    
      const token = getDecryptedToken();
      const [searchQuery, setSearchQuery] = useState("");



      const fetchNotificationByUserId = async (userId) => {

        try {

            const response = await axios.get(`${baseURL}/Notification/GetNotificationByUserID`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    userId: userId,
                },
            })
            if(response.data){
                setNotificationsData(response.data);
                setFilteredNotificationsData(response.data);
            }
            if(response.data.success == false){
                toast.error(response.data.message);
            }
           
        }catch (error){
            toast.error("Dicka shkoi keq!");
        }
      }


      const desktopColumns = [
        { field: "notificationId", headerName: "ID", width: 100 },
        { field: "title", headerName: "Titulli", width: 200 },
        { field: "message", headerName: "Mesazhi", width: 200 },
        { field: "userId", headerName: "User ID", width: 200 },
        { field: "read", headerName: "Read", width: 200},
        { field: "notificationDate", headerName: "Data", width: 200},
      ]




    return (
        <Box m="10px">
        <Header title="Notifikimet" subtitle="Kerko me id te perdoruesit " />
        <ToastContainer />
        <Box mb={2} display="flex" justifyContent="flex-start">
          <TextField
            label="Search"
            variant="outlined"
            onChange={(event) => setSearchQuery(event.target.value)}
            onKeyDown={(event) => {
                if (event.key === "Enter") {
                  fetchNotificationByUserId(searchQuery); // Only fetch when Enter is pressed
                }
              }}
            sx={{ backgroundColor: colors.primary[600], width: "30%" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          
        <Link to="/notificationsform" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px"}}
          >
            Dergo Notifikim
          </Button>
        </Link>
        </Box>
          
        <Box
          m="10px 0 0 0"
          sx={{
            "& .MuiDataGrid-root": { border: "none" },
            "& .MuiDataGrid-cell": { borderBottom: "none" },
            "& .name-column--cell": { color: "#3b0a45" },
            "& .MuiDataGrid-columnHeaders": {
             background: "black",
              borderBottom: "none",
               color: "#ffffff"
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[500],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.primary[800],
              color: "#ffffff"
             
            },
            "& .MuiButton-root": { color: "#ffffff" },
            "& .super-app-theme--header": {
              backgroundColor: colors.primary[200],
            },
            "& .MuiToolbar-root":{color :"#ffffff"},
            "&. MuiTablePagination-actions": {color: "white"}
  
          }}
        >
        <div sx={{ height: 500, width: "100%" }}>
  
        
          <DataGrid
            columns={desktopColumns}
            rows={filteredNotificationsData? filteredNotificationsData : notificationsData}
            getRowId={(row) => row.notificationId}
           
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
         
       </div>
       
        </Box>
        
      </Box>
    );
 }



 export default Notifications;